import { NEW_KNM_ID } from 'CorePackage/MainModule/routes/routes';

export const convertKnmUrlIdToId = (urlId: string | undefined) => {
  return urlId && urlId !== NEW_KNM_ID ? Number(urlId) : undefined;
};
